// Constants
export const REDUCER_NAME = 'promotions';
export const END_POINT_PROMOTIONS = '/rest/state/promotions';
export const END_POINT_PROMOTIONS_THUNDERBITE = '/rest/state/promotions?type=thunderbite';
export const END_POINT_AVAILABILITY = '/rest/state/promotions-availability';

// Actions
export const FETCH_PROMOTIONS_REQUESTED = '@komigen/promotions/FETCH_PROMOTIONS_REQUESTED';
export const FETCH_PROMOTIONS_AVAILABILITY_REQUESTED = '@komigen/promotions/FETCH_PROMOTIONS_AVAILABILITY_REQUESTED';
export const FETCH_PROMOTIONS_SUCCESS = '@komigen/promotions/FETCH_PROMOTIONS_SUCCESS';
export const FETCH_PROMOTIONS_FAILURE = '@komigen/promotions/FETCH_PROMOTIONS_FAILURE';
export const FETCH_THUNDERBITE_REQUESTED = '@komigen/promotions/FETCH_THUNDERBITE_REQUESTED';
export const FETCH_THUNDERBITE_SUCCESS = '@komigen/promotions/FETCH_THUNDERBITE_SUCCESS';
export const FETCH_THUNDERBITE_FAILURE = '@komigen/promotions/FETCH_THUNDERBITE_FAILURE';
export const FETCH_PROMOTIONS_AVAILABILITY_SUCCESS = '@komigen/promotions/FETCH_PROMOTIONS_AVAILABILITY_SUCCESS';
export const FETCH_PROMOTIONS_AVAILABILITY_FAILURE = '@komigen/promotions/FETCH_PROMOTIONS_AVAILABILITY_FAILURE';
export const AVAILABLE_BONUS_FOR_USER_UPDATE = '@komigen/promotions/AVAILABLE_BONUS_FOR_USER_UPDATE';
export const UPDATE_THUNDERBITE_TAB_OPEN = '@komigen/promotions/IS_THUNDERBITE_TAB_OPEN';
export const UPDATE_SELECTED_PROMOTIONS_SPLIT_CATEGORY =
	'@komigen/promotions/UPDATE_SELECTED_PROMOTIONS_SPLIT_CATEGORY';
export const RESET_PROMOTIONS_AVAILABILITY_HYDRATED = '@komigen/promotions/RESET_PROMOTIONS_AVAILABILITY_HYDRATED';
